export default {
  subscription: {
    manage: "管理訂閱",
    page_title: "訂閱管理",
    page_subtitle: "管理您的訂閱設定和自動續訂設定",
    current_subscription: "目前訂閱",
    plan: "方案",
    billing_cycle: "帳單週期",
    status: "狀態",
    subscription_control: "訂閱控制",
    auto_renew_cancelled: "自動續訂已取消，服務將在 {date} 到期後停止。",
    cancel_effect: "您的訂閱取消將在目前帳單週期結束後生效。您的訂閱將保持有效直到 {date}。",
    restore_prompt:
      "您的訂閱已被取消或將在目前帳單週期結束後取消。要繼續使用我們的服務，請恢復您的訂閱。",
    cancel_processing: "您的訂閱取消請求正在處理中，將在目前帳單週期結束後生效。",
    restore_processing: "您的訂閱恢復請求正在處理中。",
    expired_desc: "您的訂閱已過期。請更新您的付款資訊以恢復服務。",
    paused: "您的訂閱目前已暫停。無法執行取消或恢復操作。",
    trialing: "您目前處於試用期。試用期結束後將自動轉為付費訂閱。",
    no_action: "您的訂閱目前狀態不支援操作。",
    cancel_subscription_btn: "取消訂閱",
    restore_subscription_btn: "恢復訂閱",
    restoring: "恢復中...",
    cancelling: "取消中...",
    status_unavailable: "狀態不可用",
    no_active_subscription: "您沒有有效的訂閱",
    choose_plan: "選擇方案",
    cancel_modal_title: "取消訂閱",
    cancel_confirm:
      "您確定要取消訂閱嗎？這將在目前帳單週期結束後生效（{date}）。之後，您的訂閱將被停用，您將失去高級功能的存取權限。",
    reason_label: "原因（選填）：",
    reason_placeholder: "請分享您取消的原因...",
    status_updated: "訂閱狀態已更新",
    cancel_request_submitted: "訂閱取消請求已提交",
    cancel_failed: "訂閱取消失敗",
    restore_request_submitted: "訂閱恢復請求已提交",
    restore_failed: "訂閱恢復失敗",
    active: "有效",
    canceled: "已取消",
    cancel_pending: "取消待處理",
    restore_pending: "恢復待處理",
    past_due: "逾期",
    paused_status: "已暫停",
    trialing_status: "試用中",
    next_cycle_cancel: "下個週期取消",
    unknown_status: "未知狀態",
    monthly: "月付",
    yearly: "年付",
  },
  invoices: {
    recent: "最近發票",
    number: "發票編號",
    order_no: "訂單編號",
    amount: "金額",
    status: "狀態",
    created_at: "建立時間",
    actions: "操作",
    status_issued: "已開具",
    status_paid: "已付款",
    status_voided: "已作廢",
    view_all: "查看所有發票",
  },
  orders: {
    no: "訂單編號",
    plan_type: "方案類型",
    duration: "期間",
    amount: "金額",
    status: "狀態",
    paid_at: "付款時間",
    created_at: "建立時間",
    actions: "操作",
    quantity: "數量",
    status_pending: "待處理",
    status_paid: "已付款",
    status_failed: "失敗",
    status_refunded: "已退款",
    refund_pending: "退款待處理",
    refund_failed: "退款失敗",
    cancelled: "已取消",
    expired: "已過期",
    days: "天",
    cancel_confirm: "您確定要取消此訂單嗎？",
    delete_confirm: "您確定要刪除此訂單嗎？",
    downloading_invoice: "正在下載發票...",
    download_failed: "下載失敗",
    check_refund: "正在檢查退款資格...",
    refund_not_eligible: "不符合退款資格",
    check_refund_failed: "檢查退款資格失敗",
    prorated_refund_title: "按比例退款",
    prorated_refund_content: "此退款將根據您的使用情況按比例計算。",
    credits_refund_content: "此退款將根據剩餘點數按比例計算。",
    full_refund_title: "全額退款",
    full_refund_content: "您符合全額退款資格。",
    request_refund: "申請退款",
    processing_refund: "正在處理退款請求...",
    refund_request_failed: "退款請求失敗",
    refund_reason: "退款原因",
    refund_reason_placeholder: "請輸入退款原因...",
    refund_reason_required: "退款原因為必填項",
    refund_conditions: "退款條件",
    no_report_generated: "未產生報告",
    no_calculations_performed: "未執行計算",
    no_api_used: "未使用 API",
    subscription_period: "訂閱期間",
    subscription_details: "訂閱詳情",
    total_days: "總天數",
    remaining_days: "剩餘天數",
    refund_amount: "退款金額",
    refund_reasons: {
      order_not_found: "找不到訂單",
      unauthorized: "未經授權的存取",
      order_not_completed: "僅可退還已完成的訂單",
      subscription_not_found: "找不到訂閱",
      paid_features_used: "訂閱期間使用了付費功能",
      internal_error: "檢查退款資格時發生內部錯誤",
    },
    calculation_quota: "計算配額",
    report_quota: "報告配額",
    quota_info: "已購買 {purchased} {type}，已使用 {used}，剩餘 {remaining}",
    quota_detail: "已購買 {purchased}，已使用 {used}，剩餘 {remaining}",
    no_credits_used: "未使用點數",
    refund_requested: "退款請求提交成功",
    refund_pending_approval: "退款請求已提交。退款正在等待處理，可能需要一些時間。",
    refund_approved: "退款批准成功",
    refund_rejected: "退款請求被拒絕",
    refund_success: "退款成功",
    refund_processing: "退款處理中",
    refund_success_message: "我們已成功處理您的退款。資金可能需要 5 個工作日才能到賬。",
    refund_processing_message: "您的退款仍在處理中，請耐心等待。",
    checking_order_status: "正在檢查訂單狀態...",
  },
};
